module.exports = __webpack_public_path__ + "files/3f3732cd9d346e49ae3393e146dea197.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-5.png
// module id = 1494
// module chunks = 60